import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFormEditorActionTypes } from "../../action-types/form/IFormEditorActionTypes";
import { IFormEditorReducer } from "../../page-state-model/form/IFormEditorReducer";
const iniState: IFormEditorReducer = {
    status: ePageBaseStatus.is_not_initialization,
    formEditors: [],
    formEditorVms: [],
    dataSource: []
}
export const formEditorReducer = (state: IFormEditorReducer = iniState, action: IFormEditorActionTypes): IFormEditorReducer => {
    switch (action.type) {
        case "FORM_EDITOR_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_EDITOR_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formEditors: action.payload
            }
        case "FORM_EDITOR_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formEditors: []
            }
        case "FORM_EDITOR_LOAD_COSO_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_EDITOR_LOAD_COSO_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formEditorVms: action.payload
            }
        case "FORM_EDITOR_LOAD_COSO_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formEditorVms: []
            }
        case "FORM_EDITOR_LOAD_TRUONG_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_EDITOR_LOAD_TRUONG_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formEditorVms: action.payload
            }
        case "FORM_EDITOR_LOAD_TRUONG_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formEditorVms: []
            }
        case "FORM_EDITOR_LOAD_DATASOURCE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_EDITOR_LOAD_DATASOURCE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dataSource: action.payload
            }
        case "FORM_EDITOR_LOAD_DATASOURCE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dataSource: []
            }
        case "FORM_EDITOR_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "FORM_EDITOR_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "FORM_EDITOR_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "FORM_EDITOR_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "FORM_EDITOR_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_EDITOR_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "FORM_EDITOR_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_EDITOR_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}